import { twMerge } from 'tailwind-merge';

export const IconFacebook = ({ className, color = "#000000", size = '24' }) => {
  return (
    <svg className={twMerge('dark:[&_path]:fill-[#A9C7FF] dark:[&:hover_path]:fill-[#FCBC00] [&:hover_path]:fill-[rgb(252,188,0)]', className)} width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 2H9.36364C8.64032 2 7.94663 2.31607 7.43516 2.87868C6.9237 3.44129 6.63636 4.20435 6.63636 5V6.8H5V9.2H6.63636V14H8.81818V9.2H10.4545L11 6.8H8.81818V5C8.81818 4.84087 8.87565 4.68826 8.97794 4.57574C9.08023 4.46321 9.21897 4.4 9.36364 4.4H11V2Z" fill={color} />
    </svg>
  )
}
